import {createStyles, makeStyles} from "@material-ui/core";

export const checkPseudoStyles = {
  content: "'\\F00C'",
  fontFamily: "'Font Awesome 5 Pro'",
  fontWeight: 300, // 'fal'
  width: '1em',
  height: '1em',
  lineHeight: '1em',
  display: 'inline-block'
};
const replaceRadioWithCheckStyles = {
  // replace radio svg with fontawesome check icon
  '& svg': {
    display: 'none',
  },
  // FIXME: workaround as mui styles could be with suffix
  '& [class*="MuiIconButton-root"] [class*="MuiIconButton-label"] div::before': checkPseudoStyles
};

// we should keep all classes we can override
export default makeStyles(theme => createStyles({
  labelRoot: {
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    margin: 0,
    top: '-1em'
  },
  radioOption: {},
  formControlLabelLabel: {},
  radioGroupRoot: {
    margin: 0,
  },
  formControlLabelRoot: {
    marginLeft: 0,
    marginRight: 0,
    display: 'flex',
    borderRadius: 16,
    padding: theme.spacing(2),
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.10), 0px 1px 3px 1px rgba(0, 0, 0, 0.10)',
    width: '100%',
    border: '1px solid',
    borderColor: 'transparent',
    '&:hover': {
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.10)',
      ...replaceRadioWithCheckStyles
    },
  },
  formControlLabelChecked: {
    '& $formControlLabelLabel': {
      fontFamily: 'Roboto-Bold',
    },

    borderColor: theme.palette.primary.main,

    ...replaceRadioWithCheckStyles
  }
}));